var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTemplates = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.664 3.333a.667.667 0 0 1 .667-.667h9.333a.667.667 0 0 1 .667.667v1.333a.667.667 0 0 1-.667.667H3.331a.667.667 0 0 1-.667-.667V3.333Zm0 5.333a.667.667 0 0 1 .667-.667h4a.667.667 0 0 1 .666.667v4a.667.667 0 0 1-.666.667h-4a.667.667 0 0 1-.667-.667v-4Zm8 0a.667.667 0 0 1 .667-.667h1.333a.667.667 0 0 1 .667.667v4a.667.667 0 0 1-.667.667h-1.333a.667.667 0 0 1-.667-.667v-4Z",
  stroke: "currentColor",
  strokeWidth: 1.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgTemplates;